import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'ui';
import {
  ErrorIconContainer,
  ProcessIcon,
  ProcessIconContainer,
  StyledDivShortSteps,
  StyledFlex,
} from './steps-styles';
import { ErrorIcon } from './short-steps';

const RouteOptimisationSteps = ({
  currentStatus,
}) => {
  const renderCurrentStep = () => {
    if (currentStatus?.errors?.length || currentStatus?.isTimedOut || currentStatus?.isStale) {
      return (
        <StyledFlex ffrn aic jcc>
          {currentStatus?.processInfo?.hasMultipleProcesses ?
            <span>
              {/* eslint-disable-next-line */}
              {`(${currentStatus.processInfo.currentProcess}/${currentStatus.processInfo.totalProcesses}) ${currentStatus.processInfo.currentProcessDescription}`}
            </span> :
            null
          }
          <ErrorIconContainer jcc aic>
            <ErrorIcon type='exclamation' size='sm' />
          </ErrorIconContainer>
        </StyledFlex>
      );
    }
    return (
      <StyledFlex ffrn aic jcc>
        {currentStatus?.processInfo?.hasMultipleProcesses ?
          <span>
            {/* eslint-disable-next-line */}
            {`(${currentStatus.processInfo.currentProcess}/${currentStatus.processInfo.totalProcesses}) ${currentStatus.processInfo.currentProcessDescription}`}
          </span> :
          null
        }
        <ProcessIconContainer jcc aic>
          <ProcessIcon type='loading' size='xs' />
        </ProcessIconContainer>

      </StyledFlex>
    );
  };

  return (
    <StyledDivShortSteps >
      <Flex ffrn jcc>
        {renderCurrentStep()}
      </Flex>
    </StyledDivShortSteps>
  );
};

RouteOptimisationSteps.propTypes = {
  currentStatus: PropTypes.object,
};

export default RouteOptimisationSteps;
